/*
 *
 * ActivityReviewPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'activityReviewPage';
export const initialState = {
    is404: false,
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    review: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    params: {
        id: '',
        slug: '',
        reviewId: '',
    },
};

/* eslint-disable no-param-reassign, default-case */
function activityReviewPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            case ActionTypes.RESET_CONTENTS:
                draft.is404 = initialState.is404;
                draft.page = initialState.page;
                draft.review = initialState.review;
                return draft;
            // Page
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            // Reviews
            case ActionTypes.FETCH_REVIEW_STARTED:
                draft.review.isLoading = true;
                draft.review.isError = false;
                draft.review.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_REVIEW_SUCCESSFULLY:
                draft.review.isLoading = false;
                draft.review.isLoaded = true;
                draft.review.res = action.res;
                return draft;
            case ActionTypes.FETCH_REVIEW_FAILED:
                draft.review.isLoading = false;
                draft.review.isError = true;
                draft.review.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_REVIEW_CANCELLED:
                draft.review.isLoading = false;
                return draft;
            case ActionTypes.SET_REVIEW_IS_LOADED:
                draft.review.isLoaded = action.isLoaded;
                return draft;
            case ActionTypes.RESET_REVIEW:
                draft.review.res = null;
                return draft;
            default:
                return draft;
        }
    });
}

export default activityReviewPageReducer;
